/**
 * Initialize and return window._mfq. That array is used to send commands
 * to the mouseflow tracking script.
 * More info at https://js-api-docs.mouseflow.com/#the-_mfq-object
 * @returns {Array<[string, string | number]>} mouseflow queue array
 */

const useMouseflowQueue = () => {
  window._mfq = window._mfq || [];

  return window._mfq;
};

export default useMouseflowQueue;
